import React from 'react';
import { stats } from '../utils/mockData';
import { TrendingUp, Eye, Video, Clock } from 'lucide-react';

const iconMap = {
  "Total Views Generated": TrendingUp,
  "Average Retention Rate": Eye,
  "Videos Delivered": Video,
  "Average Turnaround": Clock
};

const StatsSection = () => {
  return (
    <section className="py-12 bg-brand-darker border-y border-brand-magenta/20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {stats.map((stat) => {
            const Icon = iconMap[stat.label];
            return (
              <div key={stat.id} className="text-center animate-fadeInUp">
                <div className="flex justify-center mb-3">
                  {Icon && <Icon className="text-brand-coral" size={32} />}
                </div>
                <div className="stat-value mb-2">{stat.value}</div>
                <div className="text-sm text-gray-400">{stat.label}</div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default StatsSection;
